/*
 * @Date: 2022-07-04 17:35:11
 * @LastEditors: chuhongguang
 */
export default {
  companyProfile: "公司简介",
  desc1: '我们是中国最大的DaaS（设备即服务）提供商、中国第一家构建数字化、多场景闭环DaaS业务模式的公司，在DaaS行业市场份额约为3.9%。DaaS作为一种新兴的企业发展趋势，将办公环境轻资产、实现可靠高效设备生命周期管理成为可能。设备生命周期管理包括一系列广泛的解决方案，涵盖IT设备整个生命周期的主要阶段，即采购、维护、管理和处置，旨在提高企业对设备的运营效率。根据CIC调研，与传统做法相比，DaaS帮助企业在三年内将运营成本降低约10%-30%我们以客户为导向的价值观指导我们为企业提供低成本、高质量、量身定制的一站式综合服务解决方案。',
  des2: ' 自成立以来，我们通过帮助企业降低运营成本，实现绿色经济和共享经济、提高IT设备的全生命周期利用率，树立了良好的企业形象。集团荣获“国家中小企业公共服务示范平台”，在2019年，被评为专精特新“小巨人”企业。我们接下来将进一步倡导一个充满活力的企业生态系统。',
  announcementsCirculars: '公告与通函',
  financialPerformance: '财报业绩',
  more: '阅读更多'
}